// Reads the app's color/font tokens straight from the CSS custom properties
// in style.css, so Chart.js never hardcodes a value that could quietly drift
// from the stylesheet when the theme changes.
function cssVar(name: string): string {
	return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
}

export interface ChartTheme {
	ink: string;
	accentFade: string;
	rule: string;
	fontMono: string;
}

export function readChartTheme(): ChartTheme {
	return {
		ink: cssVar("--ink"),
		accentFade: cssVar("--accent-fade"),
		rule: cssVar("--rule"),
		fontMono: cssVar("--font-mono"),
	};
}
